

export const getQueryParams = function(search){

    var paramsRaw = search.split("&");
    var paramsMap = new Object();
    paramsRaw.forEach(element => {
        var tmp = element.replace("?", "");
        var key = tmp.split("=");
        paramsMap[key[0]] =key[1];
    });

    return paramsMap;

   
}

export function getStatusFromEvent(event){
    if (!event){
        return null;
    }

    /*if (event.type == "PREPARE_HIT"){
        return "shot " + event.strokeIndex + " " + "Preparing to hit";
    }else if (event.type == "HIT"){
        return "shot " + event.strokeIndex + " " + "Hit - Ball in the air";
    }else if (event.type == "STROKE"){
        var stroke = JSON.parse(event.data);
        return "shot " + event.strokeIndex + " " + (stroke.lie ? stroke.lie:" stroke end");
    }else if (event.type == "RESULT"){
        var object = JSON.parse(event.data);
        return " In CUP - result " + object.result;
    }*/

    if (event.type == "PREPARE_HIT"){
        return "Preparing to hit";
    }else if (event.type == "HIT"){
        return "Ball in the air";
    }else if (event.type == "STROKE"){
        var stroke = JSON.parse(event.data);
        return  (stroke.lie ? stroke.lie:" stroke end");
    }else if (event.type == "RESULT"){
        var object = JSON.parse(event.data);
        return "Result " + object.result;
    }
    console.log("getStatusFromEvent unknown event", event);
    return "";
}


export function getRoundIndex(player){

    if (!player || !player.currentRound){
        return "1";
    }

   return "" + player.currentRound;
}

export function getHoleIndex(player){

    if (!player || !player.currentHole){
        return "1";
    }

   return "" + player.currentHole;
}

export function getPlayerEventsMap(events){
    var map = new Object();
    if (!events){
        return map;
    }

    events.forEach(element => {
        var array = map[element.playerId];
        if (!array){
            array = new Array();
        }
        array.unshift(element);
        map[element.playerId] = array; 
    });

    return map;

}
export function getResultAsText(result){
    if (result === 0){
        return "PAR";
    }
    if (!result){
        return "";
    }
    else
    if (result === 1){
        return "BOGEY";
    }else
    if (result === 2){
        return "D. BOGEY";
    }
    else
    if (result > 2 || result <-2){
        return "OTHER"+"("+result+")";
    }else
    if (result === -1){
        return "BIRDIE";
    }
    else
    if (result === -2){
        return "EAGLE";
    }
}
export function getPlayers(leaderboard){
    if (!leaderboard){
        return [];
    }

    let groups = leaderboard.groups;
    if (!groups){
        return[];
    }
    var maxround = 1;
    groups.forEach(element => {
        if (element.round && element.round > maxround){
            maxround = element.round;
        }
     });

    let players = [];
    var group_players = [];
    groups.forEach(element => {
        if (element.round && element.round == maxround){
            group_players = element.players;
            group_players.forEach(p => {
                p.groupid = element.id;
                p.startTime = element.startTime.substring(11, 16);
            });
            players= players.concat(group_players);

        }
    });

    return players;
}




// WEBPACK FOOTER //
// ./src/Common/utils.js